import { axiosInstance } from '~/src/config/config_axios'
import { convertData, IHistoryData } from './helper/convertData'

export class MemberRepository {
  async getSupportHistory(): Promise<IHistoryData> {
    const res = await axiosInstance.get('/support-histories')
    return convertData(res.data)
  }
}
